<style>
    :root {
        --white:                     #fefefe;
        --darkgrey:                  #323232;
        --lightgrey:                 #787878;
    }

    div.dashboard-item {
        display:                grid;
        grid-template-columns:  1fr 4fr 1fr;
	      grid-template-rows:     auto;
        color:                  var(--white);
        border-color:           var(--darkgrey);
        border-radius:          20px;
        border-style:           solid;
        padding:                1rem;
        font-size:              1rem;
        font-family:            'latolight';
        text-align:             left;
    }
    div.dashboard-item h2 {
        grid-row:               1;
        grid-column:            2;
        font-size:              2rem;
        margin:                 0;
        padding:                1rem 0 0 0;
    }
    div.dashboard-item img.item-icon {
        grid-row:               1;
        grid-column:            1 / 2;
        min-width:              5rem;
        margin-right:           2rem;
    }
    div.item-inner {
        grid-column:            1 / 3;
        grid-row:               2 / 5;
    }
    div.item-expand-toggle {
        grid-column:            4;
        grid-row:               2;
        color:                  var(--lightgrey);
        font-size:              2rem;
        cursor:                 pointer;
    }
</style>

<script>
    export let profile  = "None",
	             language = "None",
	             level    = 0,
	             streak   = 0;
</script>

<div class="dashboard-item">
    <img alt src="assets/duolingo_icon.svg" class="item-icon">
    <h2>{profile}</h2>
    <div class="item-inner">
        <h3>Recently Studied: {language}</h3>
      	<h3>Level: {level}</h3>
      	<h3>Streak: {streak}</h3>
    </div>
    <div class="item-expand-toggle">&#8964;</div>
</div>
